type SubRow = Record<string, unknown> | null | undefined;

function str(v: unknown): string {
  return typeof v === 'string' ? v : '';
}

export function inferSubscriptionSlots(type: SubRow): number | null {
  if (!type) return null;
  const num = type.num_slots;
  if (typeof num === 'number' && num > 0) return num;
  if (typeof num === 'string' && num.trim() !== '' && !Number.isNaN(Number(num)) && Number(num) > 0) {
    return Number(num);
  }
  const name = str(type.name);
  const first = name.charAt(0);
  if (first && !Number.isNaN(Number(first)) && Number(first) > 0) return Number(first);
  if (name.includes('one_')) return 1;
  if (name.includes('two_')) return 2;
  return null;
}

export function isSubscriptionLimitTitle(title?: string): boolean {
  if (!title) return false;
  return /abonnement|subscription|activation not possible|error/i.test(title);
}
